import { isSupportedDocumentFileType } from '@quipex/core/config';
import {
    toDocumentFileNameParts,
    type DocumentFileNameParts,
} from '@quipex/shared/ui';
import type { QuippySource } from '../../../runtime';

export function toQuippySourceFileName(
    source: Pick<QuippySource, 'title' | 'url'>
): DocumentFileNameParts {
    const titleParts = toDocumentFileNameParts(source.title);
    const urlParts = toUrlFileNameParts(source.url);
    const supportedTitleBadge =
        titleParts.badge &&
        isSupportedDocumentFileType(titleParts.badge.label.toLowerCase())
            ? titleParts.badge
            : null;
    const badge = urlParts?.badge ?? supportedTitleBadge;

    return {
        title:
            supportedTitleBadge ||
            (badge && titleParts.badge?.label === badge.label)
                ? titleParts.title
                : source.title,
        badge,
    };
}

function toUrlFileNameParts(url: string): DocumentFileNameParts | null {
    try {
        const fileName = new URL(url).pathname.split('/').at(-1) ?? '';
        return toDocumentFileNameParts(decodeURIComponent(fileName));
    } catch {
        return null;
    }
}
